import React from 'react';
import PropTypes from 'prop-types';

export default class Dropdown extends React.Component {
	static propTypes = {
		nameColumn: PropTypes.string,
		sortTable: PropTypes.func,
		formatColumn: PropTypes.string,
		closeDropdownAfterOrdering: PropTypes.func
	}

	static defaultProps = {
		nameColumn: '',
		sortTable: null,
		formatColumn: '',
		closeDropdownAfterOrdering: null
	}

	state = {
		labelAsc: '',
		labelDesc: '',
	}

	componentDidMount() {
		this.setSortingLabelByLanguage()
	}
	/**
	 * @description Verifica se a coluna é do tipo texto
	 * @returns True ou false
	 */
	columnFormatTypeIsText() {
		const { formatColumn } = this.props
		const typeText = [
			'text',
			'document',
			'radio',
			'checkbox',
		]

		return typeText.includes(formatColumn)
	}

	setCssDropdown() {
		return {
			position: 'absolute',
			zIndex: '600',
		}
	}

	setCssDropdownContent() {
		return {
			marginTop: '5px',
			width:'200px',
			height:'auto',
			zIndex: '100',
			position: 'absolute',
			display: 'flex',
			flexDirection: 'column',
			backgroundColor: '#fff',
			border: 'solid #454545 1px',
			borderRadius: '8px',
			boxShadow: '1px 1px 6px #989898',
			overflow: 'hidden',
		}
	}

	setCssLineDropdown() {
		return {
			backgroundColor: '#fff',
			position: 'relative',
			zIndex: '100',
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			cursor: 'pointer',
			padding: '10px 0 10px 10px',
		}
	}

	setCssSpan() {
		return {
			fontWeight: '400',
			fontSize: '16px',
		}
	}

	setCssIcon() {
		return { marginRight: '10px' }
	}

	/**
	 * @description Define o label da ordenação no dropdown através do idioma pré-definido.
	 */
	setSortingLabelByLanguage() {
		const language = window.Realize.i18n

		this.columnFormatTypeIsText()
		? this.setState({
			labelAsc: language.t('template.actions.sortAscText'),
			labelDesc: language.t('template.actions.sortDescText'),
		})
		: this.setState({
			labelAsc: language.t('template.actions.sortAscNumber'),
			labelDesc: language.t('template.actions.sortDescNumber'),
		})
	}

	/**
	 * @description Realiza a ordenação da tabela por coluna, decrescente ou crescente
	 * @param {String} directionSort Tipo de Ordenação ('ASC' ou 'DESC')
	 */
	clickToOrder(directionSort) {
		const { sortTable, nameColumn } = this.props
		sortTable(nameColumn, directionSort)
		this.props.closeDropdownAfterOrdering()
	}

	render() {
		const { labelAsc, labelDesc } = this.state;

		return (
			<div style={this.setCssDropdown()}>
				<div style={this.setCssDropdownContent()}>
					<div
						onClick={() => this.clickToOrder('ASC')}
						style={this.setCssLineDropdown()}
					>
						<i className="material-icons" style={this.setCssIcon()}>arrow_upward</i>
						<span style={this.setCssSpan()}>
							{labelAsc}
						</span>
					</div>
					<div
						onClick={() => this.clickToOrder('DESC')}
						style={this.setCssLineDropdown()}
					>
						<i className="material-icons"  style={this.setCssIcon()}>arrow_downward</i>
						<span style={this.setCssSpan()}>
							{labelDesc}
						</span>
					</div>
				</div>
			</div>
		)
	}
}
